export const imageCodes = {
    banner: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwacolbanner.png?alt=media&token=569b3e49-a62a-414c-a32b-8112b05a722f"
    },
    baby1: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG_2165.PNG?alt=media&token=748a71bc-a919-47ea-9df0-8742b829a20c"
    },
    baby2: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbaby3.png?alt=media&token=5e7c3984-6b1d-48db-8619-7576a9b64df7"
    },
    baby3: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbaby2.png?alt=media&token=d1b4cd87-0e3a-4293-ab90-68a8d2ce1013"
    },
    baby4: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbaby4.png?alt=media&token=e81b745b-16a0-402b-bc21-96cf6a283747"
    },
    lady1: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flady1.png?alt=media&token=ea8c886b-dbb5-4208-8ae1-7591fa3c7b58"
    },
    lady2: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flady1.png?alt=media&token=ea8c886b-dbb5-4208-8ae1-7591fa3c7b58"
    },
    lady3: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flady2.png?alt=media&token=3d53232d-1313-435e-8017-a7ffe3ba9106"
    },
    lady4: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flady3.png?alt=media&token=de108144-f7c3-4c95-a077-c340c4745860"
    },
    lady5: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flady4.png?alt=media&token=7c819576-ef33-4a1e-8fbb-40c84cf53f93"
    },
    lady6: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flady5.png?alt=media&token=0c8f270c-f17d-4629-8e21-b35149c3bfd5"
    },
    man1: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fman1.png?alt=media&token=d02045e1-9ce3-424b-aa5f-83643a151de4"
    },
    man2: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fman2.png?alt=media&token=1aa98f80-f429-415f-877d-f6f0fcbbd7db"
    },
    man3: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fman3.png?alt=media&token=4dd03d8e-5a94-4fab-9793-4dee9f32fc67"
    },
    man4: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fman4.png?alt=media&token=9415a742-f186-447f-af14-4da6564f6513"
    },
    man5: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fman5.png?alt=media&token=82b2745d-1202-4bfc-b790-fde87861a4d6"
    },
    other1: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fother1.png?alt=media&token=08801660-69e1-4855-bc10-e3550daebe98"
    },
    other2: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fother2.png?alt=media&token=ae8b8aa6-1f1b-4a88-98fc-f400858831d1"
    },
    other3: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fother3.png?alt=media&token=10760046-c6a7-4c66-8239-21b594353922"
    },
    zeroImg: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG_2165.PNG?alt=media&token=fab683f7-c065-42c8-9bd4-23199607c08a"
    },
}

export const titleCodes = {
    baby: {
        code: "${merchantId}_tmpl_title_1",
        title: "ကလေးဝတ်"
    },
    woman: {
        code: "${merchantId}_tmpl_title_2",
        title: "အမျိုးသမီးဝတ်"
    },
    man: {
        code: "${merchantId}_tmpl_title_3",
        title: "အမျိုးသားဝတ်"
    },
    other: {
        code: "${merchantId}_tmpl_title_4",
        title: "အခြားပစ္စည်းများ"
    },
    bestSeller: {
        code: "${merchantId}_tmpl_title_5",
        title: "ရောင်းအားအကောင်းဆုံးအထည်များ"
    },
    shipping: {
        code: "${merchantId}_tmpl_title_6",
        title: "ပစ္စည်းပို့ဆောင်ရေး"
    },
    contact: {
        code: "${merchantId}_tmpl_title_7",
        title: "ဆက်သွယ်ရန်"
    },
    about: {
        code: "${merchantId}_tmpl_title_8",
        title: "About Us"
    },
}